export const contactNJson = {
  branch: "Computer Science",
  medium: "English",
  eventId: "EVT12345",
  email: "student@example.com",
  firstName: "John",
  lastName: "Doe",
  gender: "Male",
  dob: "1998-05-15",
  maritalStatus: "Single",
  alternatePhone: "9876543210",
  city: "New York",
  state: "New York",

  // 12th Details
  board: "CBSE",
  passingYear12: "2016",
  stream: "Science",
  percentage12: "88%",

  // Bachelor's Details
  universityUG: "XYZ University",
  passingYearUG: "2020",
  subjectUG: "Computer Science",
  percentageUG: "75%",

  // Master's Details
  universityPG: "ABC University",
  passingYearPG: "2022",
  subjectPG: "Software Engineering",
  percentagePG: "80%",

  // Preferences
  preferredDegree: "Master's",
  preferredCountry: "Canada",
  preferredField: "AI & Data Science",
  preferredIntake: "Fall 2025",

  // Additional Information
  workExperience: "2 years",
  givenTest: "Yes",
  testName: "IELTS",
  heardFrom: "Online Ads",
  otherComments: "Looking for scholarship opportunities",
};

export const sourcesHeard = [
  "Website",
  "Facebook",
  "Instagram",
  "Friends",
  "SMS",
  "Email",
  "Other",
];
